import { AgGridReact } from 'ag-grid-react';
import { Center, Loader, UnstyledButton } from '@mantine/core';
import SearchIcon from '../../components/icons/Search';
import { useInventory } from './Inventory.hooks';
import classes from './Inventory.styles.tsx.module.css';
import { useInventoryEvents } from './Inventory.Events.hooks';
import { BNEmptyState } from '../../components/EmptyState/EmptyState';
import { useFlag } from '@unleash/proxy-client-react';
import { TenantIdEventId } from '../../models/tenantIdListingId';

export default function EventsGrid() {
  const { inventoryQuickFilter, setInventoryQuickFilter, setFilter } = useInventory('onCellClickedWhenDirty', 'inventoryQuickFilter', 'setInventoryQuickFilter', 'setFilter');
  const { gridRef, events, columnDefs, defaultColumnSettingDefs, onRowSelectionChanged, onGridReady, onRowDataUpdated, trySaveGridState, onCellClickedWhenDirty } =
    useInventoryEvents(
      'gridRef',
      'events',
      'columnDefs',
      'defaultColumnSettingDefs',
      'onRowSelectionChanged',
      'onGridReady',
      'onRowDataUpdated',
      'trySaveGridState',
      'onCellClickedWhenDirty',
    );

  function CustomNoRowsOverlay() {
    return (
      <Center>
        <BNEmptyState
          title="No Results Found"
          description="Try adjusting the filter options"
          bottomContent={
            inventoryQuickFilter && (
              <UnstyledButton
                mt={10}
                onClick={() => {
                  setFilter('');
                  setInventoryQuickFilter('');
                }}
                className={classes.grayLink}
              >
                or clear quick filter
              </UnstyledButton>
            )
          }
          icon={<SearchIcon color="var(--colors-iconFill)" size={28} />}
          iconBg="var(--colors-opacity-hover)"
          h={320}
          w={320}
          border={false}
        />
      </Center>
    );
  }

  function CustomLoadingOverlay() {
    return (
      <div className={`ag-overlay-loading-center ${classes.agOverlayLoadingCenter}`}>
        <Loader color="var(--colors-gray-5)" type="dots" />
      </div>
    );
  }

  const enableCellTextSelection = useFlag('grid-text-selection');

  return (
    <div id="inventory-events-grid" className="ag-theme-alpine">
      <AgGridReact
        ref={gridRef}
        rowData={events}
        suppressScrollOnNewData
        columnDefs={columnDefs}
        onGridReady={onGridReady}
        onRowDataUpdated={onRowDataUpdated}
        rowSelection={{
          mode: 'multiRow',
          enableClickSelection: false,
          checkboxes: false,
          // Suppress AG-Grid's auto-generated selection column. In multiRow mode headerCheckbox
          // defaults to true (isSelectionColumnEnabled = checkboxes || headerCheckbox), which adds
          // an extra column. Selection lives in the dragCell column (SelectionCell/SelectionHeader).
          headerCheckbox: false,
        }}
        onRowSelected={onRowSelectionChanged}
        rowBuffer={50}
        getRowId={(params) => TenantIdEventId.create(params.data.tenantId, params.data.eventId).toString()}
        onCellClicked={onCellClickedWhenDirty}
        onColumnMoved={trySaveGridState}
        onColumnResized={trySaveGridState}
        onSortChanged={trySaveGridState}
        onColumnVisible={trySaveGridState}
        defaultColDef={defaultColumnSettingDefs}
        enableCellTextSelection={enableCellTextSelection}
        headerHeight={32}
        rowHeight={36}
        rowStyle={{
          lineHeight: '28px',
          fontSize: '12px',
        }}
        noRowsOverlayComponent={CustomNoRowsOverlay}
        loadingOverlayComponent={CustomLoadingOverlay}
        suppressContextMenu
        tooltipShowDelay={1000}
      />
    </div>
  );
}
